import {IBreadcrumbState} from '../state/breadcrumb.state';
import {BREADCRUMB_ACTION, BreadcrumbAction} from '../action/breadcrumb.action';

const initialBreadcrumbState: IBreadcrumbState = {
  breadcrumbs: [],
};

export function breadcrumbReducer(
  state: IBreadcrumbState = initialBreadcrumbState,
  action: BreadcrumbAction,
): IBreadcrumbState {
  switch (action.type) {
    case BREADCRUMB_ACTION.INIT_BREADCRUMB:
      return {
        ...state,
        ...action.payload,
      };

    case BREADCRUMB_ACTION.RESET_BREADCRUMB:
      return initialBreadcrumbState;
    default:
      return state;
  }
}
